import moment from 'moment'

export const listToDay = ( list=[] )=> {

    let output = {};
    let parsedStart = '';
    for(let [i, time] of list.entries()){
        parsedStart = moment(time.start).locale('en').format('YYYY-MM-DD')
        if(!output[parsedStart]){
            output[parsedStart] = [];
        }
        time.index = i;
        output[parsedStart].push(time)
    }
    return output
}

export const dayToName = ( timeList=[] )=> {
    let output = {};
    for(let time of timeList){
        if(!output[ time.name + '-' + time.project.id ] && time.name){
            output[time.name + '-' + time.project.id] = {list:[], project: time.project, name: time.name};
            output[time.name + '-' + time.project.id].list.push(time);
        }else if(time.name){
            output[time.name + '-' + time.project.id].list.push(time);
        }else{
            output[ time.id + '-' + time.project.id ] = {list:[time], project: time.project, name: time.name}
        }
        
    }
    return output;
}

export const listToProjet = ( list=[] )=> {

    let output = {};
    for(let [i, time] of list.entries()){
        if(!output[time.project.name]){
            output[time.project.name] = [];
        }
        time.index = i;
        output[time.project.name].push(time)
    }
    return output
}

export const calculateDuration = ( input={}, inMs=false ) => {

    let output = '';
    let startTime = {};
    let endTime = {};
    let duration = {};
    let timeInSeconds = 0;
    let s = 0;
    let m = 0;
    let h = 0;
    
    if( Array.isArray(input) ){
        for(let time of input){
            endTime = moment(time.end).locale('en');
            startTime = moment(time.start).locale('en');
            duration = moment.duration(endTime.diff(startTime));
            timeInSeconds += parseInt(duration.asSeconds(), 10)
        }
    }else{
        endTime = moment(input.end).locale('en');
        startTime = moment(input.start).locale('en');
        duration = moment.duration(endTime.diff(startTime));
        timeInSeconds += parseInt(duration.asSeconds(), 10)
    }
    if( inMs ){
        return timeInSeconds;
    }else{
        h = parseInt(timeInSeconds/3600, 10);
        m = parseInt(timeInSeconds/60, 10) - h*60;
        s = timeInSeconds - m*60 - h*3600;

        output = h + ":" + ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2)
        return output;
    }
    
}

export const creatStartEnd = (start= '', end= '', date= moment() ) => {
    const breakStartTime = start.split(':');
    const newStartDate = date.set({hours:breakStartTime[0], minute:breakStartTime[1], second:0}).format('YYYY-MM-DDTHH:mm:ss');
    const breakEndTime = end.split(':');
    let newEndDate = '';

    if( parseInt(breakEndTime[0], 10)*60 + parseInt(breakEndTime[1], 10) >=  parseInt(breakStartTime[0], 10)*60 + parseInt(breakStartTime[1], 10) ){
        newEndDate = date.set({hours:breakEndTime[0], minute:breakEndTime[1], second:0}).format('YYYY-MM-DDTHH:mm:ss');
    }else{
        newEndDate = date.add(1, 'days').set({hours:breakEndTime[0], minute:breakEndTime[1], second:0}).format('YYYY-MM-DDTHH:mm:ss');
    }
    return {start: newStartDate, end: newEndDate}
}

export const checkRecordInList = (list=[], record={}, parametr='id') => {
    let result = false;
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if( element[parametr] === record[parametr] ){
            result = i;
            break;
        }
    }
    return result;
}